// config.js

export const SALENG_GREEN_API_PROD = "https://api.saleng.tjl.co.th";
// export const SALENG_GREEN_API_DEV = "http://localhost:8001";
// export const SALENG_GREEN_API_DEV = "http://192.168.0.105:8001";
// export const SALENG_SHOP_API_PROD = "https://shop-api-v2.saleng.tjl.co.th";
export const SALENG_SHOP_API_PROD = "https://api.akka.getkaset.com";
// export const SALENG_SHOP_API_PROD = "http://localhost:9002";
export const LOCAL_URL = "http://localhost:3001";
// export const LOCAL_URL = "http://192.168.0.242:3001";

// export const SALENG_SHOP_API_DEV = "http://192.168.0.105:8002";